module.exports = __webpack_public_path__ + "media/src/images/apple-icon-60x60-93dffd31aa1bf1226723378446d10f82.png";